let Choices = require( 'choices.js' );
let forms   = require( './forms' );

let add_to_cart_form = ( function ( $ ) {

	let $form;

	let $ticket_tier;

	let _init = function () {
		$form = $( '#add_to_cart_form' );

		if ( $form.length > 0 ) {
			$ticket_tier = $form.find( '#add_to_cart_form-field-wrap-ticket_tier' );

			if ( $ticket_tier.length > 0 ) {
				$ticket_tier.find( 'input[type="radio"]' ).on( 'change', _toggle_top_fields )
			}

			let $dietary_req = $( '#add_to_cart_form-dietary_req' );

			$dietary_req.on( 'change', _maybe_show_other_dietary );

			$form.find( '#add_to_cart_form-field-wrap-ticket_for' ).find( 'select' ).on( 'change', _toggle_lower_fields );

			$form.find( '#add_to_cart_form-membership_number' ).on( 'keydown keyup keypress', _disable_submit_via_return );
			$form.find( '#add_to_cart_form-student_number' ).on( 'keydown keyup keypress', _disable_submit_via_return );
			$form.find( '#add_to_cart_form-discount_code' ).on( 'keydown keyup keypress', _disable_submit_via_return );

			let $membership_number = $form.find( '#add_to_cart_form-field-wrap-membership_number' );

			$membership_number.find( 'input' ).wrap( '<div class="inner"/>' );
			$membership_number.find( '.inner' ).wrap( '<div class="num-wrap"/>' );
			$membership_number.find( '.inner' ).append( '<a href="#" class="button save-form" data-form="add_to_cart_form" data-savesource="membership">Apply</a>');

			let $student_number = $form.find( '#add_to_cart_form-field-wrap-student_number' );

			$student_number.find( 'input' ).wrap( '<div class="inner"/>' );
			$student_number.find( '.inner' ).wrap( '<div class="num-wrap"/>' );
			$student_number.find( '.num-wrap' ).append( '<div class="student-application">Don\'t have a student discount code yet? <a href="' + ScriptData.student_application + '">Apply here.</a></div>' );
			$student_number.find( '.inner' ).append( '<a href="#" class="button save-form" data-form="add_to_cart_form" data-savesource="student">Apply</a>');

			let $discount_code = $form.find( '#add_to_cart_form-field-wrap-discount_code' );

			$discount_code.find( 'input' ).wrap( '<div class="inner"/>' );
			$discount_code.find( '.inner' ).wrap( '<div class="num-wrap"/>' );
			$discount_code.find( '.inner' ).append( '<a href="#" class="button save-form" data-form="add_to_cart_form" data-savesource="discount">Apply</a>');

			forms.init_save_buttons();

			$form.on( 'form_submitted', _form_submitted );
		}
	};

	let _disable_submit_via_return = function( e ) {
		if ( 'enter' === e.key.toLowerCase() ) {
			e.stopImmediatePropagation();
			e.preventDefault();

			let $wrap_div  = $( this ).closest( '.field-wrap' );
			let $error_div = $wrap_div.find( '.field-errors' );

			$wrap_div.addClass( 'has-errors' );
			$error_div.addClass( 'has-errors' );
			$error_div.html( '<span class="intention">Please click the \'Apply\' button to apply your code</span>' );
		}
	};

	let _maybe_show_other_dietary = function( e ) {
		let $select = $( '#add_to_cart_form-dietary_req' );

		let selected = $select.val();

		if ( selected && ( selected.indexOf( 'Other' ) >= 0 || selected.indexOf( 'other' ) >= 0 ) ) {
			$( '#add_to_cart_form-field-wrap-dietary_req_other' ).slideDown()
		} else {
			$( '#add_to_cart_form-field-wrap-dietary_req_other' ).slideUp()
		}
	};

	let _form_submitted = function( e, response ) {
		if ( ! $form.hasClass( 'show-notices' ) ) {
			if ( response.autosave && typeof response.field_errors.email_address.invalid_user !== 'undefined' ) {
				forms.display_field_errors( $form, {
					email_address: {
						invalid_user: response.field_errors.email_address.invalid_user
					}
				} );
			} else {
				forms.display_field_errors( $form, {
					email_address: {}
				} );
			}
		}

		if ( response.manual_save ) {
			forms.display_field_errors( $form, response.field_errors );

			switch( response.save_source ) {
				case 'discount':
					if ( response.valid ) {
						$form.find( '#add_to_cart_form-discount_code' ).prop( 'disabled', 'disabled' );
						$form.find( '#add_to_cart_form-discount_code' ).next( 'a.save-form' ).css( 'pointer-events', 'none' );
					}
					break;
				case 'membership':
					if ( response.valid ) {
						$form.find( '#add_to_cart_form-membership_code' ).prop( 'disabled', 'disabled' );
						$form.find( '#add_to_cart_form-membership_code' ).next( 'a.save-form' ).css( 'pointer-events', 'none' );
					}
					break;
				case 'student':
					if ( response.valid ) {
						$form.find( '#add_to_cart_form-student_number' ).prop( 'disabled', 'disabled' );
						$form.find( '#add_to_cart_form-student_number' ).next( 'a.save-form' ).css( 'pointer-events', 'none' );
					}
					break;
			}
		}
	};

	let _toggle_top_fields = function ( e ) {
		if ( $( this ).is( ':checked' ) ) {
			$form.find( '#add_to_cart_form-field-wrap-ticket_for' ).slideDown();

			let val = $( this ).val();

			let $membership_number = $form.find( '#add_to_cart_form-field-wrap-membership_number' );
			let $student_number = $form.find( '#add_to_cart_form-field-wrap-student_number' );

			val.indexOf( 'member' ) >= 0 ? $membership_number.slideDown() : $membership_number.slideUp();
			val.indexOf( 'student' ) >= 0 ? $student_number.slideDown() : $student_number.slideUp();
		}

		_maybe_show_discount_code();
	};

	let _toggle_lower_fields = function( e ) {
		let $affected_items = $form.find( '.field-wrap.hide-wrap' );
		$affected_items = $affected_items.not( '#' + $( this ).closest( '.field-wrap' ).attr( 'id' ) );
		$affected_items = $affected_items.not( '#add_to_cart_form-field-wrap-membership_number' );
		$affected_items = $affected_items.not( '#add_to_cart_form-field-wrap-student_number' );
		$affected_items = $affected_items.not( '#add_to_cart_form-field-wrap-discount_code' );
		$affected_items = $affected_items.not( '#add_to_cart_form-field-wrap-dietary_req_other' );

		let val = $( this ).val().toLowerCase();

		if ( val !== 'please select' ) {
			$affected_items.slideDown();
		} else {
			$affected_items.slideUp();
		}

		_maybe_show_discount_code();

		if ( 'user' === val ) {
			$form.find( '#add_to_cart_form-email_address' ).prop( 'disabled', 'disabled' );
			$form.find( '#add_to_cart_form-first_name' ).prop( 'disabled', 'disabled' );
			$form.find( '#add_to_cart_form-last_name' ).prop( 'disabled', 'disabled' );
			$form.find( '#add_to_cart_form-phone_number' ).prop( 'disabled', 'disabled' );
			$form.find( '#add_to_cart_form-organisation' ).prop( 'disabled', 'disabled' );

			if ( typeof forms.choices['add_to_cart_form-country'] !== 'undefined' ) {
				forms.choices[ 'add_to_cart_form-country' ].disable();
			} else {
				$form.find( '#add_to_cart_form-country' ).prop( 'disabled', 'disabled' );
			}

			$form.find( '.edit-details-div > a' ).show();
		} else {
			const to_enable = [
				$form.find('#add_to_cart_form-email_address'),
				$form.find('#add_to_cart_form-first_name'),
				$form.find('#add_to_cart_form-last_name'),
				$form.find('#add_to_cart_form-phone_number'),
				$form.find('#add_to_cart_form-organisation')
			];

			for (const $enable of to_enable) {
				$enable.prop( 'disabled', false );
				$enable.val( '' );
			}

			if ( typeof forms.choices['add_to_cart_form-country'] !== 'undefined' ) {
				forms.choices[ 'add_to_cart_form-country' ].enable();
				forms.choices[ 'add_to_cart_form-country' ].setChoiceByValue( 'Please select' );
			} else {
				const $country_field = $form.find( '#add_to_cart_form-country' );
				$country_field.prop( 'disabled', false );
				$country_field.val( '' );
			}

			$form.find( '.edit-details-div > a' ).hide();
		}
	};

	let _maybe_show_discount_code = function() {
		let show = true;

		if ( show && $ticket_tier.length > 0 ) {
			let active_tier = $ticket_tier.find( 'input:checked' ).val();

			let is_member = active_tier.indexOf( 'member' ) >= 0;
			let is_student = active_tier.indexOf( 'student' ) >= 0;

			show = ! is_member && ! is_student;
		}

		show = show && $form.find( '#add_to_cart_form-field-wrap-ticket_for' ).find( 'select' ).val().toLowerCase() !== 'please select';

		let $el = $form.find( '#add_to_cart_form-field-wrap-discount_code' );

		show ? $el.slideDown() : $el.slideUp();
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = add_to_cart_form;